const historyData = [
  { year: '2025年07月', event: '東京都品川区内で本店移転' },
  { year: '2025年07月', event: '労働者派遣事業を取得' },
  { year: '2024年10月', event: 'ISO/IEC 27001:2022を取得' },
  { year: '2021年08月', event: '東京都品川区内で本店移転' },
  { year: '2020年10月', event: 'ISO/IEC 27001:2013を取得' },
  { year: '2019年09月', event: '東京都品川区内で本店移転' },
  { year: '2014年10月', event: '東京都渋谷区より品川区へ本店移転' },
  { year: '2008年12月', event: '東京都品川区より東京都渋谷区へ本店移転' },
  { year: '2008年12月', event: '合同会社MSKから株式会社MSKへ組織変更' },
  { year: '2008年04月', event: '神奈川県横浜市より東京都品川区へ本店移転' },
  { year: '2006年08月', event: '合同会社MSKを設立' },
];

const CompanyHistory = () => {
  return (
    <section className="py-24 bg-[#F8FBF6]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter']">
            History
          </p>
          <h4 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
            沿革
          </h4>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[100px] md:left-[160px] top-0 bottom-0 w-px bg-[#89B56B]/20"></div>

          <div className="space-y-0">
            {historyData.map((item, index) => (
              <div key={index} className="flex items-start gap-6 group">
                <div className="flex-shrink-0 w-[80px] md:w-[140px] text-right py-5">
                  <span className="text-[13px] font-bold text-[#89B56B]">{item.year}</span>
                </div>

                <div className="relative flex-shrink-0 flex items-center justify-center py-5">
                  <div className="w-3 h-3 rounded-full bg-white border-2 border-[#89B56B] group-hover:bg-[#89B56B] transition-colors z-10"></div>
                </div>

                <div className="flex-1 py-5 border-b border-gray-100 last:border-b-0">
                  <p className="text-[13px] text-gray-700 leading-relaxed group-hover:text-[#3F6844] transition-colors">
                    {item.event}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyHistory;
